/** @module Unread tester feedback, for the badges in the admin tabs and on "Mehr". */
import { useQuery } from "@tanstack/react-query";

import { api, problemFrom } from "@/api/client";

/** One small request a minute; only administrators ask. */
export function useOpenFeedback(enabled: boolean): number {
  const query = useQuery({
    queryKey: ["admin", "feedback", "count"],
    queryFn: async () => {
      const { data, response } = await api.GET("/api/v1/admin/feedback", {
        params: { query: { status: "open", limit: 1 } },
      });
      if (!data) throw problemFrom(response);
      return data.open;
    },
    enabled,
    refetchInterval: 60_000,
  });
  return query.data ?? 0;
}
